<template>
  <div class="">
      <div v-if="!noSpaceAbove" class="spacer" style="height:40px"></div>

      <h1 v-if="level == 1" 
        :id="anchor ? anchor : ''">
        <span class='title is-size-5 is-size-6-mobile' style="margin-bottom:5px; text-transform:uppercase" v-if="preheading">{{preheading}}</span>
        <span class='title' :class="long ? 'is-size-2 is-size-3-mobile' : 'is-size-1 is-size-2-mobile'" style="margin-bottom:0">{{heading}}</span>
        <span class='title is-size-5 is-size-6-mobile' style="margin-top:10px; text-transform:uppercase" v-if="subheading">{{subheading}}</span>
      </h1>

      <h2 v-if="!level == 1" 
        :id="anchor ? anchor : ''">
        <span class='is-size-5 is-size-6-mobile' style="margin-bottom:5px; text-transform:uppercase" v-if="preheading">{{preheading}}</span>
        <!-- <span class='title is-size-2 is-size-2-mobile' style="margin-bottom:0">{{heading}}</span> -->
        <span class='title' :class="smaller ? 'is-size-3 is-size-3-mobile' : 'is-size-2 is-size-2-mobile'" style="margin-bottom:0">{{heading}}</span>
        <span class='is-size-5 is-size-6-mobile' style="margin-top:10px; text-transform:uppercase" v-if="subheading">{{subheading}}</span>
      </h2>
      <!-- <div v-if="!subheading" class="spacer" style="height:40px"></div>
      <h3 class='title is-size-5 is-size-6-mobile' style="margin-top:5px; text-transform:uppercase" v-if="subheading">{{noTitleCase ? heading : $titleCase(subheading)}}</h3> -->
      <div v-if="!noSpaceBelow" class="spacer" style="height:40px"></div>
      <div v-if="noSpaceBelow" class="spacer" style="height:10px"></div>
  </div>
</template>

<script>
export default {
  name: 'Heading',
  props: ['preheading', 'heading', 'subheading', 'anchor', 'noTitleCase', 'noSpaceBelow', 'noSpaceAbove', 'level', 'smaller', 'long'],
  data () {
    return {
      
    }
  },
  methods: {
   
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  span.title {
    display:block;
  }
</style>


// WEBPACK FOOTER //
// src/components/Heading.vue